import { v4 as uuidv4 } from "uuid";
import { addUserReading } from "../firebase/user";
import { firestore, storage } from "../firebase/config";
import Swal from 'sweetalert2';

const divID = "blueToothReadingsDivfingertipPulseOximeter";

export const onCaptureImageButtonClick4 = (uid) => {
  document.getElementById(divID).innerHTML = "ᛒluetooth";
  localStorage.setItem('completed_fpo', 10);
  CaptureImageComponent(uid);
};

function CaptureImageComponent(userId) {
  let output = {};
  let imageURL = '';
  
  const handleCapture = async (userId) => {
    try {
      const imageFile = await captureImage(); 
      const fileName = `${userId}/${uuidv4()}`;
      const storageRef = storage.ref(`images/${fileName}`);
      const snapshot = await storageRef.put(imageFile); // Upload image to Firebase Storage
      const downloadURL = await snapshot.ref.getDownloadURL(); // Get the download URL

      // Send image URL to remote service
      const response = await fetch(
        "https://sharprpm-ocr-pulseox-test1-850861419930.us-central1.run.app",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data: downloadURL }),
        }
      );

      if (response.ok) {
        const result = await response.json();
        imageURL = downloadURL;
        output = result;
        handleConfirm(userId, imageURL, output);
      } else {
        throw new Error("Failed to process image");
      }
    } catch (error) {
      console.error("Error capturing or processing image:", error);
      Swal.fire({
        title: 'Error',
        text: `An error occurred while processing the image. Please try again.`,
        icon: 'error',
      });
    }
  };

  const handleConfirm = async (userId, imageURL) => {
    const dateNow = new Date(Date.now());
    const labelsArray = ["SpO₂", "Pulse Rate (PR)", "Perfusion Index (PI)", "Date Time"];

    document.getElementById(divID).innerHTML = `ᛒ${divID}`
    localStorage.setItem('completed_fpo', 30);

    try {
      // Save to Firestore
      await firestore.collection("posts").add({
        userId,
        timestamp: dateNow,
        image: imageURL,
        response: output,
      });

      const element  = [
        output.SpO2, output.PR, output.PI,
        //0,
        dateNow.toLocaleString()
      ]
      const index = 2;
      // Display table with reading data
      createTable(labelsArray, [output.SpO2, output.PR, output.PI, dateNow.toLocaleString()],`table${index}`, imageURL);
      saveReading(userId, output, dateNow);
    } catch (error) {
      console.error("Error confirming post:", error);
    }
  };

  handleCapture(userId); // Call the capture function
}

const saveReading = (uid, reading, dateTime) => {
  const time = dateTime.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const date = dateTime.toLocaleDateString().replace(/(\d+)\/(\d+)\/(\d+)/, "$3-$1-$2");

  let validationMsg = "";
  let validationMsg2 = "";

  // Validation for SpO2 and PR
  if (reading.SpO2 < 70 || reading.SpO2 > 100) {
    validationMsg += "<br>- SpO₂ level out of normal range (70-100%)";
  }
  if (reading.PR < 30 || reading.PR > 200) {
    validationMsg += "<br>- Pulse Rate out of normal range (30-200 BPM)";
    validationMsg2 = "Call your doctor.";
  }

  Swal.fire({
    title: 'Confirm Reading',
    html: `SpO₂: ${reading.SpO2}% <br>
           PR: ${reading.PR} BPM <br>
           PI: ${reading.PI}% <br>
           <span style="color: red; font-weight: bold; display: block;">${validationMsg}</span><br><br>
           If wrong, click "Cancel", or If correct, click "OK"<br> 
           <span style="color: red; font-weight: bold;">${validationMsg2}</span>`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
  }).then((result) => {
    const status = result.isConfirmed ? "Accepted" : "Rejected";
    addUserReading({
      uid,
      add: {
        devices: {
          fingertipPulseOximeter: {
            time,
            date,
            status,
            note: `Picture Captured`,
            reading: { SpO2: reading.SpO2, PR: reading.PR },
            device: { manufacturer: "Device", model: "Camera" },
          },
        },
      },
    });
    document.getElementById(`disposition_${divID}`).innerHTML = 
      status === "Accepted" ? "Reading saved!" : "Reading rejected.";
    if (status === "Accepted") new Audio('/audio/ReadingAccepted.mp3').play();
  });
};

async function captureImage() {
  return new Promise((resolve, reject) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.capture = "environment"; // Ensure this works on target devices (mobile)
    
    input.addEventListener("change", (event) => {
      const file = event.target.files[0];
      if (file) {
        resolve(file);
      } else {
        reject(new Error("No image selected"));
      }
    });

    input.click();
  });
}

function createTable(labelArray, colDataArray, tableClassName, imageURL) {
  if (document.getElementById(divID).innerHTML === `ᛒ${divID}`) {
    document.getElementById(divID).innerHTML = "";
    localStorage.setItem('completed_fpo', 100);
  }

  let table = document.createElement("table"),
    thead = document.createElement("thead"),
    tbody = document.createElement("tbody"),
    th, tr, td;

  th = document.createElement("th");
  th.innerHTML = "Camera";
  thead.appendChild(th);

  th = document.createElement("th");
  th.innerHTML = `<div id=disposition_${divID}>Reading pending</div>`;
  thead.appendChild(th);

  table.setAttribute("class", tableClassName);
  table.appendChild(thead);
  table.appendChild(tbody);

  //document.body.appendChild(table);
  document.getElementById(divID).appendChild(table);

  for (let i = 0; i < colDataArray.length; i++) {
    tr = document.createElement("tr");

    //for label
    td = document.createElement("td");
    td.innerHTML = labelArray[i];
    td.style.color = "blue";
    tr.appendChild(td);

    //for data
    td = document.createElement("td");
    td.style.color = "black";
    td.innerHTML = colDataArray[i];
    tr.appendChild(td);
    table.appendChild(tr);
  }

  tr = document.createElement("tr");
  td = document.createElement("td");
  td.colSpan = 2;

  const img = document.createElement("img");
  img.src = imageURL;
  // Set the width and height of the image (optional)
  img.width = "200";
  img.height = "150";
  // Append the image to the table data cell
  td.appendChild(img);
  tr.appendChild(td);

  tbody.appendChild(tr);
};